import React, {Component} from 'react';
import PrintSSRGeneralDoc from './PrintSSRGeneralDoc';

class PrintSSRInvoiceDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {}

  }

  componentDidMount(){

  }

  render() {
    return(
      <PrintSSRGeneralDoc
        title={'ใบแจ้งหนี้'} 
        doc={'invoice_doc'}
        docNo={this.props.ivNo}
        param={'iv'}
      >
      </PrintSSRGeneralDoc>
    )
  }
}  

export default PrintSSRInvoiceDoc;


// WEBPACK FOOTER //
// ./src/view/print/ssr/PrintSSRInvoiceDoc.js